exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "#dict-corpora {\n    height: 100% !important;\n    width: 100% !important;\n    /*border: 1px solid #dcdcdc !important;*/\n    border-radius: 2px;\n    padding-left: 0 !important;\n    padding-right: 0 !important;\n}", ""]);

